<template>
  <div v-loading="loading" class="stepContent">
    <div class="matchBox">
      <div class="matchTitle">
        <p>客户名称</p>
        <p>盈创投资管理有限公司</p>
      </div>
      <div class="matchList">
        <div class="showAll">
          <el-checkbox v-model="checked">显示全部表头</el-checkbox>
        </div>
        <div class="matchTable">
          <el-table
            :data='checked?tableData:filteredTableData'
            style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
            >
            </el-table-column>
            <el-table-column
              prop="columnName"
              label="Excel表头字段"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="系统字段"
            >
              <template slot-scope="scope">
                <el-select @change="changeData" v-if="checked" v-model="tableData[scope.$index].sys"
                           :class="{nodata:checked?!tableData[scope.$index].sys:!filteredTableData[scope.$index].sys}" placeholder="未匹配">
                  <el-option-group
                    v-for="group in options"
                    :key="group.id"
                    :label="group.setName">
                    <el-option
                      v-for="item in group.wageItemList"
                      :key="item.id"
                      :label="item.itemName"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
                <el-select @change="changeData" v-else v-model="filteredTableData[scope.$index].sys"
                           :class="{nodata:checked?!tableData[scope.$index].sys:!filteredTableData[scope.$index].sys}" placeholder="未匹配">
                  <el-option-group
                    v-for="group in options"
                    :key="group.id"
                    :label="group.setName">
                    <el-option
                      v-for="item in group.wageItemList"
                      :key="item.id"
                      :label="item.itemName"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="recommend"
              label="智能推荐字段">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="uploadTip">
      <div class="uploadTip-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-tishi"></use>
        </svg>
        温馨提示
      </div>
      <div class="uploadTip-lists">
        <div class="uploadTip-list">
          1、当Excel导入的信息项目与系统薪资项名称完全一致时，系统自动匹配
        </div>
        <div class="uploadTip-list">
          2、未匹配的薪资项下的数据将不予导入
        </div>
        <div class="uploadTip-list">
          3、系统自动记录对应关系，如导入模板未发生变化，无需重复匹配
        </div>
      </div>
    </div>
    <div v-if="next" class="next-btn">
      <el-button type="primary" @click="goback" size="mini">上一步</el-button>
      <el-button type="primary" @click="nextStep" size="mini">下一步</el-button>
    </div>
  </div>
</template>
<script>
  import {uploadStepTwo} from "@/api/wage/batchTemplate";
  export default {
    components:{
      // eslint-disable-next-line vue/no-unused-components
      uploadStepTwo
    },
    props:{
      step2Info:{
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        checked: false,
        next: true,
        filteredTableData: [],//未匹配
        batchId: this.step2Info.headerInfo.batchId,
        fileId: this.step2Info.headerInfo.fileId,
        tableData: this.step2Info.headerInfo.headerList, //表格数据,
        options:  this.step2Info.headerInfo.templateItemList, //候选表头
        batchInfo: this.step2Info.batchInfo
      };
    },
    created(){
      this.filteredTableData = this.tableData.filter(function(data,index) {
        if (!data.sys) {
          return data;
        }
      });
    },
    mounted() {

    },
    watch: {
      checked:function(val){
        // 不选中时更新未匹配列表
        if(!val){
          this.filteredTableData = this.filteredTableData.filter(function(data,index) {
            if (!data.sys) {
              data.inx = index
              return data;
            }
          });
        }
        console.log(this.filteredTableData)
      }
    },
    methods: {
      nextStep() {
        // this.$emit("next"); // 跳转下一步

        this.$set(this.batchInfo,'id',this.batchId)
        let paramMap={
          batchInfo: this.batchInfo,
          tableData: this.tableData,
          fileId: this.fileId
        }
        uploadStepTwo(paramMap).then(res => {
          let rs=res.data
          if(rs.code==0){
            console.log('batchId:'+JSON.stringify(rs.data))
            this.$emit('next',rs.data)

          }else{
            this.$message.error('出现错误');
          }
        })
      },
      goback() {
        this.$emit("goback"); // 返回
      }
    }
  };
</script>
<style scoped rel="stylesheet/scss">
  .stepContent {
    width: 92%;
    margin: 20px auto 0;
    box-shadow: 0px 0px 10px #dedede;
    padding: 30px;
    border-radius: 5px;
  }

  .next-btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  .matchTable {
    margin-bottom: 20px;
  }

  .nodata >>> input::-webkit-input-placeholder {
    color: red;
  }

 /* .nodata >>> input::-moz-input-placeholder {
    color: red;
  }*/

  .nodata >>> input::-ms-input-placeholder {
    color: red;
  }

  .uploadTip {
    background-color: #eeeeee;
    padding: 20px;
    color: #666666;
    font-size: 12px;
  }

  .uploadTip-title {
    font-size: 16px;
    color: #333333;
    line-height: 30px;
  }

  .uploadTip-lists {
    padding-left: 20px;
  }

  .uploadTip-list {
    line-height: 30px;
  }

  .uploadTip-list .uploadTip-button {
    color: #269cff;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
